import { useCallback } from 'react';

export const useNotificationSound = (_options = {}) => {
  const playNotification = useCallback(async () => {}, []);

  const playSuccess = useCallback(async () => {
    await playNotification();
  }, [playNotification]);

  const playError = useCallback(async () => {
    await playNotification();
  }, [playNotification]);

  return {
    playNotification,
    playSuccess,
    playError
  };
};
